import toObject from "@/store/utils/to-object";

const search = {
  namespaced: true,
  state: {
    searchTerm: "",
    tag: "",
    resultsPerPage: 6,
    maps: {
      isFetching: false,
      isErrored: false,
      results: {},
      error: {},
      page: 1,
      numPages: 1,
      numResults: 0,
    },
    datasets: {
      isFetching: false,
      isErrored: false,
      results: {},
      error: {},
      page: 1,
      numPages: 1,
      numResults: 0,
    },
    tags: {
      isFetching: false,
      isErrored: false,
      results: [],
      error: {},
      page: 1,
      numPages: 1,
      numResults: 0,
    },
  },
  getters: {
    requestParameters(state) {
      const parameters = {
        per_page: state.resultsPerPage,
        shared: "yes",
        exclude_shared: false,
      };

      if (state.searchTerm) {
        parameters.q = state.searchTerm;
      }

      if (state.tag) {
        parameters.tags = state.tag;
      }

      return parameters;
    },
  },
  mutations: {
    updatePage(state, { section, page }) {
      state[section].page = page;
    },
    setFetchingState(state, section) {
      state[section].isFetching = true;
    },
    setRequestError(state, { requestType, error }) {
      state[requestType].error = error;
    },
    setMaps(state, maps) {
      state.maps.results = toObject(maps.visualizations, "id");
      state.maps.numResults = maps.total_entries;
      state.maps.numPages = Math.ceil(
        maps.total_entries / state.resultsPerPage
      );

      state.maps.isFetching = false;
    },
    updateVisualization(state, { visualizationId, visualizationAttributes }) {
      const visualization =
        state.maps.results[visualizationId] ||
        state.datasets.results[visualizationId];

      if (visualization) {
        Object.assign(visualization, visualizationAttributes);
      }
    },
    resetState(state) {
      state.searchTerm = "";
      state.tag = "";

      state.maps = {
        isFetching: false,
        isErrored: false,
        results: {},
        error: {},
        page: 1,
        numPages: 1,
        numResults: 0,
      };
    },
  },
  actions: {
    fetchMaps(context, parameters) {
      context.rootState.client.getVisualization(
        "",
        {
          ...parameters,
          types: "derived,kuviz",
          page: context.state.maps.page,
        },
        function (error, _, data) {
          if (error) {
            return context.commit("setRequestError", {
              requestType: "maps",
              error,
            });
          }

          context.commit("setMaps", data);
        }
      );
    },
    resetState(context) {
      context.commit("resetState");
    },
  },
};

export default search;
